type Props = {
    text: string;
}

const WarningAlert = ({ text }: Props) => {
    return (
        <div className="flex bg-red-200 border border-red-400 rounded-lg p-4 mb-4 justify-center text-sm text-red-700" role="alert">
            {text}
        </div>
    )
}

export default WarningAlert